import { Table } from "src/requests/table/types";
import { RootState } from "../types";
import { OverviewTablesByTemplateId } from "./types";

export const getIsOverviewTablesLoading = (state: RootState): boolean =>
  state.overviewTables.isLoading;

export const getOverviewTablesById = (
  state: RootState
): OverviewTablesByTemplateId => state.overviewTables.byId;

export const getOverviewTableForTemplateId = (
  state: RootState,
  templateId: number
): Table | undefined => getOverviewTablesById(state)[templateId];

export const getOverviewTablesForTemplateIds = (
  state: RootState,
  templateIds: number[]
): OverviewTablesByTemplateId => {
  const entries = templateIds.map((templateId) => [
    templateId,
    getOverviewTableForTemplateId(state, templateId),
  ]);

  return Object.fromEntries(entries);
};
